import { WeekdayCode } from './types';

export const WEEKDAYS: Array<{ code: WeekdayCode; long: string; short: string }> = [
	{ code: 0, short: 'Sun', long: 'Sunday' },
	{ code: 1, short: 'Mon', long: 'Monday' },
	{ code: 2, short: 'Tue', long: 'Tuesday' },
	{ code: 3, short: 'Wed', long: 'Wednesday' },
	{ code: 4, short: 'Thu', long: 'Thursday' },
	{ code: 5, short: 'Fri', long: 'Friday' },
	{ code: 6, short: 'Sat', long: 'Saturday' },
];

export const WEEKDAY_PRESETS: Record<'weekdays' | 'weekends' | 'all', WeekdayCode[]> = {
	weekdays: [1, 2, 3, 4, 5],
	weekends: [0, 6],
	all: [0, 1, 2, 3, 4, 5, 6],
};

